import {addEventNote, deleteEventNote, updateEventNote} from "../Notes/BrowserDatabaseFunctions";


export const E_addEventNoteResults = async (_incoming) => {
    console.log("E_addNewNoteResults");

    try {
        if (_incoming?.result !== "ok") {
            console.log("Add result not ok");
            return null;
        }

        const eventId = _incoming.event_id;
        const newNote = _incoming.note; // should already contain { id, temp_id?, ... }

        if (!eventId || !newNote) {
            console.error("Missing event_id or note in payload");
            return null;
        }

        // Persist to browser DB (best-effort)
        try {
            await addEventNote(eventId, newNote);
            console.log("Note added successfully");
        } catch (error) {
            console.error("Error adding Note to Browser database: ", error);
        }

        return null;

    } catch (e) {
        console.log("ERROR:", e);
        return null;
    }
};

export const E_updateEventNoteResults = async (_incoming) => {
    console.log("E_updateEventNoteResults");

    /*
        an Event Note was updated
     */

    try {
        const _result = _incoming.result;

        if (_result === "ok") {
            try {
                await updateEventNote(_incoming.event_id, _incoming.note);
                console.log("Note updated successfully");
            } catch (error) {
                console.error("Error updating Note: ", error);
            }

            return null; // Return the updated meal regardless of success or failure

        } else {
            console.log("Update result not ok");
            return null; // Return null if the result is not ok
        }

    } catch (e) {
        console.log("ERROROROR : " + e);
        return null; // Return null if there was a top-level error
    }
}

export const E_deleteEventNoteResults = async (_incoming) => {
    console.log("E_deleteEventNoteResults");

    /*
        an Event Note was deleted
     */


    try {

        const _result = _incoming.result;

        if (_result === "ok") {

            try {
                await deleteEventNote(_incoming.event_id, _incoming.note_id);
                console.log("Note deleted successfully");
            } catch (error) {
                console.error("Error deleting Note: ", error);
            }

        }
    } catch (e){
        console.log("ERROROROR : "+e);
    }

}